module.exports = __webpack_public_path__ + "static/Statistics-mla.a173b1bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Statistics-mla.jpg
// module id = 509
// module chunks = 172546399187757